/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrentProviderDetail } from '../models/CurrentProviderDetail';
import type { PaginatedProviderListList } from '../models/PaginatedProviderListList';
import type { ProviderCredentialingDocuments } from '../models/ProviderCredentialingDocuments';
import type { ProviderCredentialingEducation } from '../models/ProviderCredentialingEducation';
import type { ProviderCredentialingIdentification } from '../models/ProviderCredentialingIdentification';
import type { ProviderCredentialingImmunization } from '../models/ProviderCredentialingImmunization';
import type { ProviderCredentialingInsurances } from '../models/ProviderCredentialingInsurances';
import type { ProviderCredentialingLicenses } from '../models/ProviderCredentialingLicenses';
import type { ProviderCredentialingMisc } from '../models/ProviderCredentialingMisc';
import type { ProviderCredentialingPersonal } from '../models/ProviderCredentialingPersonal';
import type { ProviderCredentialingProfessionalTraits } from '../models/ProviderCredentialingProfessionalTraits';
import type { ProviderCredentialingRatesAndDifferentials } from '../models/ProviderCredentialingRatesAndDifferentials';
import type { ProviderDetail } from '../models/ProviderDetail';
import type { ProviderLimitedDetail } from '../models/ProviderLimitedDetail';
import type { ProviderPermissions } from '../models/ProviderPermissions';
import type { ProviderPublicDetail } from '../models/ProviderPublicDetail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderService {

    /**
     * Copy of django-rest-framework's `ListAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns PaginatedProviderListList
     * @throws ApiError
     */
    public static providerList({
        boardCertificationsTypeOverlap,
        certificationsTypeOverlap,
        displayNameIcontains,
        hasImlc,
        licensedStatesOverlap,
        limit,
        marketplaceHourlyFeeGte,
        marketplaceHourlyFeeLte,
        myProvider,
        offset,
        order,
        schedulesStartOnGte,
        schedulesStartOnLte,
        specialtiesOverlap,
    }: {
        /**
         * * `ABAI` - ABAI (American Board of Allergy and Immunology)
         * * `ABA` - ABA (American Board of Anesthesiology)
         * * `ABD` - ABD (American Board of Dermatology)
         * * `ABEM` - ABEM (American Board of Emergency Medicine)
         * * `ABFM` - ABFM (American Board of Family Medicine)
         * * `ABIM` - ABIM (American Board of Internal Medicine)
         * * `ABMGG` - ABMGG (American Board of Medical Genetics and Genomics)
         * * `ABNS` - ABNS (American Board of Neurological Surgery)
         * * `ABOG` - ABOG (American Board of Obstetrics and Gynecology)
         * * `ABO` - ABO (American Board of Ophthalmology)
         * * `ABOS` - ABOS (American Board of Orthopedic Surgery)
         * * `ABOHNS` - ABOHNS (American Board of Otolaryngology - Head and Neck Surgery)
         * * `ABPATH` - ABPath (American Board of Pathology)
         * * `ABP` - ABP (American Board of Pediatrics)
         * * `ABPMR` - ABPMR (American Board of Physical Medicine and Rehabilitation)
         * * `ABPS` - ABPS (American Board of Physician Specialties)
         * * `ABPM` - ABPM (American Board of Preventive Medicine)
         * * `ABPN` - ABPN (American Board of Psychiatry and Neurology)
         * * `ABR` - ABR (American Board of Radiology)
         * * `ABS` - ABS (American Board of Surgery)
         * * `ABTS` - ABTS (American Board of Thoracic Surgery)
         * * `ABU` - ABU (American Board of Urology)
         * * `ABUCM` - ABUCM (American Board of Urgent Care Medicine)
         * * `AMCB` - AMCB (American Midwifery Certification Board)
         * * `AOBA` - AOBA (American Osteopathic Board of Anesthesiology)
         * * `AOBD` - AOBD (American Osteopathic Board of Dermatology)
         * * `AOBEM` - AOBEM (American Osteopathic Board of Emergency Medicine)
         * * `AOBFM` - AOBFM (American Osteopathic Board of Family Medicine)
         * * `AOBIM` - AOBIM (American Osteopathic Board of Internal Medicine)
         * * `AOBNMM` - AOBNMM (American Osteopathic Board of Neuromusculoskeletal Medicine)
         * * `AOBNM` - AOBNM (American Osteopathic Board of Nuclear Medicine)
         * * `AOBOG` - AOBOG (American Osteopathic Board of Obstetrics and Gynecology)
         * * `AOBO` - AOBO (American Osteopathic Board of Ophthalmology)
         * * `AOBOS` - AOBOS (American Osteopathic Board of Orthopedic Surgery)
         * * `AOBOTO` - AOBOTO (American Osteopathic Board of Otolaryngology)
         * * `AOBPA` - AOBPa (American Osteopathic Board of Pathology)
         * * `AOBP` - AOBP (American Osteopathic Board of Pediatrics)
         * * `AOBPMR` - AOBPMR (American Osteopathic Board of Physical Medicine and Rehabilitation)
         * * `AOBPM` - AOBPM (American Osteopathic Board of Preventative Medicine)
         * * `AOBPR` - AOBPR (American Osteopathic Board of Proctology)
         * * `AOBPN` - AOBPN (American Osteopathic Board of Psychiatry and Neurology)
         * * `AOBR` - AOBR (American Osteopathic Board of Radiology)
         * * `AOBS` - AOBS (American Osteopathic Board of Surgery)
         * * `AANP` - American Academy of Nurse Practitioners
         * * `ANCC` - American Nurses Credentialing Center
         * * `NBPAS` - NBPAS (National Board of Physicians and Surgeons)
         * * `NCCPA` - National Commission on Certification of Physician Assistants
         * * `NONE` - Not Boarded
         */
        boardCertificationsTypeOverlap?: Array<'AANP' | 'ABA' | 'ABAI' | 'ABD' | 'ABEM' | 'ABFM' | 'ABIM' | 'ABMGG' | 'ABNS' | 'ABO' | 'ABOG' | 'ABOHNS' | 'ABOS' | 'ABP' | 'ABPATH' | 'ABPM' | 'ABPMR' | 'ABPN' | 'ABPS' | 'ABR' | 'ABS' | 'ABTS' | 'ABU' | 'ABUCM' | 'AMCB' | 'ANCC' | 'AOBA' | 'AOBD' | 'AOBEM' | 'AOBFM' | 'AOBIM' | 'AOBNM' | 'AOBNMM' | 'AOBO' | 'AOBOG' | 'AOBOS' | 'AOBOTO' | 'AOBP' | 'AOBPA' | 'AOBPM' | 'AOBPMR' | 'AOBPN' | 'AOBPR' | 'AOBR' | 'AOBS' | 'NBPAS' | 'NCCPA' | 'NONE'>,
        /**
         * * `ACLS` - ACLS (Advanced Cardiac Life Support)
         * * `ATLS` - ATLS (Advanced Life Trauma Support)
         * * `BLS` - BLS (Basic Life Support)
         * * `PALS` - PALS (Pediatric Advanced Life Support)
         * * `NRP` - NRP (Neonatal Resuscitation Program)
         * * `OTHER` - Other
         */
        certificationsTypeOverlap?: Array<'ACLS' | 'ATLS' | 'BLS' | 'NRP' | 'OTHER' | 'PALS'>,
        displayNameIcontains?: string,
        hasImlc?: boolean,
        /**
         * * `AL` - Alabama
         * * `AK` - Alaska
         * * `AS` - American Samoa
         * * `AZ` - Arizona
         * * `AR` - Arkansas
         * * `AA` - Armed Forces Americas
         * * `AE` - Armed Forces Europe
         * * `AP` - Armed Forces Pacific
         * * `CA` - California
         * * `CO` - Colorado
         * * `CT` - Connecticut
         * * `DE` - Delaware
         * * `DC` - District of Columbia
         * * `FL` - Florida
         * * `GA` - Georgia
         * * `GU` - Guam
         * * `HI` - Hawaii
         * * `ID` - Idaho
         * * `IL` - Illinois
         * * `IN` - Indiana
         * * `IA` - Iowa
         * * `KS` - Kansas
         * * `KY` - Kentucky
         * * `LA` - Louisiana
         * * `ME` - Maine
         * * `MD` - Maryland
         * * `MA` - Massachusetts
         * * `MI` - Michigan
         * * `MN` - Minnesota
         * * `MS` - Mississippi
         * * `MO` - Missouri
         * * `MT` - Montana
         * * `NE` - Nebraska
         * * `NV` - Nevada
         * * `NH` - New Hampshire
         * * `NJ` - New Jersey
         * * `NM` - New Mexico
         * * `NY` - New York
         * * `NC` - North Carolina
         * * `ND` - North Dakota
         * * `MP` - Northern Mariana Islands
         * * `OH` - Ohio
         * * `OK` - Oklahoma
         * * `OR` - Oregon
         * * `PA` - Pennsylvania
         * * `PR` - Puerto Rico
         * * `RI` - Rhode Island
         * * `SC` - South Carolina
         * * `SD` - South Dakota
         * * `TN` - Tennessee
         * * `TX` - Texas
         * * `UT` - Utah
         * * `VT` - Vermont
         * * `VI` - Virgin Islands
         * * `VA` - Virginia
         * * `WA` - Washington
         * * `WV` - West Virginia
         * * `WI` - Wisconsin
         * * `WY` - Wyoming
         */
        licensedStatesOverlap?: Array<'AA' | 'AE' | 'AK' | 'AL' | 'AP' | 'AR' | 'AS' | 'AZ' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'GU' | 'HI' | 'IA' | 'ID' | 'IL' | 'IN' | 'KS' | 'KY' | 'LA' | 'MA' | 'MD' | 'ME' | 'MI' | 'MN' | 'MO' | 'MP' | 'MS' | 'MT' | 'NC' | 'ND' | 'NE' | 'NH' | 'NJ' | 'NM' | 'NV' | 'NY' | 'OH' | 'OK' | 'OR' | 'PA' | 'PR' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VA' | 'VI' | 'VT' | 'WA' | 'WI' | 'WV' | 'WY'>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        marketplaceHourlyFeeGte?: number,
        marketplaceHourlyFeeLte?: number,
        myProvider?: boolean,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Ordering
         *
         * * `display_name` - Display name
         * * `-display_name` - Display name (descending)
         * * `marketplace_hourly_fee` - Marketplace hourly fee
         * * `-marketplace_hourly_fee` - Marketplace hourly fee (descending)
         * * `peer_rating` - Peer rating
         * * `-peer_rating` - Peer rating (descending)
         * * `leader_rating` - Leader rating
         * * `-leader_rating` - Leader rating (descending)
         */
        order?: Array<'-display_name' | '-leader_rating' | '-marketplace_hourly_fee' | '-peer_rating' | 'display_name' | 'leader_rating' | 'marketplace_hourly_fee' | 'peer_rating'>,
        schedulesStartOnGte?: string,
        schedulesStartOnLte?: string,
        /**
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialtiesOverlap?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
    }): CancelablePromise<PaginatedProviderListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/',
            query: {
                'board_certifications__type__overlap': boardCertificationsTypeOverlap,
                'certifications__type__overlap': certificationsTypeOverlap,
                'display_name__icontains': displayNameIcontains,
                'has_imlc': hasImlc,
                'licensed_states__overlap': licensedStatesOverlap,
                'limit': limit,
                'marketplace_hourly_fee__gte': marketplaceHourlyFeeGte,
                'marketplace_hourly_fee__lte': marketplaceHourlyFeeLte,
                'my_provider': myProvider,
                'offset': offset,
                'order': order,
                'schedules__start_on__gte': schedulesStartOnGte,
                'schedules__start_on__lte': schedulesStartOnLte,
                'specialties__overlap': specialtiesOverlap,
            },
        });
    }

    /**
     * @returns ProviderDetail
     * @throws ApiError
     */
    public static providerRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<ProviderDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/{provider_id}/',
            path: {
                'provider_id': providerId,
            },
        });
    }

    /**
     * @returns ProviderLimitedDetail
     * @throws ApiError
     */
    public static providerLimitedRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<ProviderLimitedDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/{provider_id}/limited/',
            path: {
                'provider_id': providerId,
            },
        });
    }

    /**
     * @returns ProviderPermissions
     * @throws ApiError
     */
    public static providerPermissionsRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<ProviderPermissions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/{provider_id}/permissions/',
            path: {
                'provider_id': providerId,
            },
        });
    }

    /**
     * @returns ProviderPublicDetail
     * @throws ApiError
     */
    public static providerPublicRetrieve({
        providerId,
    }: {
        providerId: string,
    }): CancelablePromise<ProviderPublicDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/{provider_id}/public/',
            path: {
                'provider_id': providerId,
            },
        });
    }

    /**
     * @returns CurrentProviderDetail
     * @throws ApiError
     */
    public static providerCurrentRetrieve(): CancelablePromise<CurrentProviderDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current',
        });
    }

    /**
     * @returns ProviderCredentialingDocuments
     * @throws ApiError
     */
    public static providerCurrentCredentialingDocumentsRetrieve(): CancelablePromise<ProviderCredentialingDocuments> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/documents',
        });
    }

    /**
     * @returns ProviderCredentialingDocuments
     * @throws ApiError
     */
    public static providerCurrentCredentialingDocumentsUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingDocuments,
    }): CancelablePromise<ProviderCredentialingDocuments> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/documents',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingEducation
     * @throws ApiError
     */
    public static providerCurrentCredentialingEducationRetrieve(): CancelablePromise<ProviderCredentialingEducation> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/education',
        });
    }

    /**
     * @returns ProviderCredentialingEducation
     * @throws ApiError
     */
    public static providerCurrentCredentialingEducationUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingEducation,
    }): CancelablePromise<ProviderCredentialingEducation> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/education',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingIdentification
     * @throws ApiError
     */
    public static providerCurrentCredentialingIdentificationRetrieve(): CancelablePromise<ProviderCredentialingIdentification> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/identification',
        });
    }

    /**
     * @returns ProviderCredentialingIdentification
     * @throws ApiError
     */
    public static providerCurrentCredentialingIdentificationUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingIdentification,
    }): CancelablePromise<ProviderCredentialingIdentification> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/identification',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingImmunization
     * @throws ApiError
     */
    public static providerCurrentCredentialingImmunizationRetrieve(): CancelablePromise<ProviderCredentialingImmunization> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/immunization',
        });
    }

    /**
     * @returns ProviderCredentialingImmunization
     * @throws ApiError
     */
    public static providerCurrentCredentialingImmunizationUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingImmunization,
    }): CancelablePromise<ProviderCredentialingImmunization> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/immunization',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingInsurances
     * @throws ApiError
     */
    public static providerCurrentCredentialingInsuranceRetrieve(): CancelablePromise<ProviderCredentialingInsurances> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/insurance',
        });
    }

    /**
     * @returns ProviderCredentialingInsurances
     * @throws ApiError
     */
    public static providerCurrentCredentialingInsuranceUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingInsurances,
    }): CancelablePromise<ProviderCredentialingInsurances> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/insurance',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingLicenses
     * @throws ApiError
     */
    public static providerCurrentCredentialingLicensesRetrieve(): CancelablePromise<ProviderCredentialingLicenses> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/licenses',
        });
    }

    /**
     * @returns ProviderCredentialingLicenses
     * @throws ApiError
     */
    public static providerCurrentCredentialingLicensesUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingLicenses,
    }): CancelablePromise<ProviderCredentialingLicenses> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/licenses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingMisc
     * @throws ApiError
     */
    public static providerCurrentCredentialingMiscRetrieve(): CancelablePromise<ProviderCredentialingMisc> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/misc',
        });
    }

    /**
     * @returns ProviderCredentialingMisc
     * @throws ApiError
     */
    public static providerCurrentCredentialingMiscUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingMisc,
    }): CancelablePromise<ProviderCredentialingMisc> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/misc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingPersonal
     * @throws ApiError
     */
    public static providerCurrentCredentialingPersonalRetrieve(): CancelablePromise<ProviderCredentialingPersonal> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/personal',
        });
    }

    /**
     * @returns ProviderCredentialingPersonal
     * @throws ApiError
     */
    public static providerCurrentCredentialingPersonalUpdate({
        requestBody,
    }: {
        requestBody: ProviderCredentialingPersonal,
    }): CancelablePromise<ProviderCredentialingPersonal> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/personal',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingProfessionalTraits
     * @throws ApiError
     */
    public static providerCurrentCredentialingProfessionalTraitsRetrieve(): CancelablePromise<ProviderCredentialingProfessionalTraits> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/professional-traits',
        });
    }

    /**
     * @returns ProviderCredentialingProfessionalTraits
     * @throws ApiError
     */
    public static providerCurrentCredentialingProfessionalTraitsUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingProfessionalTraits,
    }): CancelablePromise<ProviderCredentialingProfessionalTraits> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/professional-traits',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderCredentialingRatesAndDifferentials
     * @throws ApiError
     */
    public static providerCurrentCredentialingRatesDifferentialsRetrieve(): CancelablePromise<ProviderCredentialingRatesAndDifferentials> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider/current/credentialing/rates-differentials',
        });
    }

    /**
     * @returns ProviderCredentialingRatesAndDifferentials
     * @throws ApiError
     */
    public static providerCurrentCredentialingRatesDifferentialsUpdate({
        requestBody,
    }: {
        requestBody?: ProviderCredentialingRatesAndDifferentials,
    }): CancelablePromise<ProviderCredentialingRatesAndDifferentials> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider/current/credentialing/rates-differentials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
